
export const paths = {
  // Sports routes
  sports: {
    home: (categoryId) => `/sports/${categoryId}`,
    groundListing: (categoryId) => `/sports/ground-listing/${categoryId}`,
    providerDetail: (providerId) => `/sports/provider-detail/${providerId}`,
    slotBook: "/sports/slot-book",
    bookingSummary: "/sports/booking-summary",
    serviceSelect: "/sports/service-select",
    bookingConfirm: "/sports/booking-confirm",
    play: "/sports/play",
    createGame: "/sports/create-game",
    joinGame: `/sports/join-game/:id`,
    myGames: "/sports/my-games",
  },
  events: {
    list: (categoryId) => `/events/${categoryId}`,
    detail: (serviceId) => `/events/detail/${serviceId}`,
    addTicket: "/events/add-ticket",
    bookingForm: "/events/booking-form",
    thanks: "/events/thanks",
    myTicket: (bookingId) => `/events/my-ticket/${bookingId}`,
    cancelBooking: "/events/cancel-booking",
    ticketDetail: (bookingId) => `/events/booking-detail/${bookingId}`,
  },
  salon: {
    list: (categoryId) => `/salon/${categoryId}`,
    servicesList: (providerId) => `/salon/services/${providerId}`,
    slotSelection: "/salon/slots-selection",
    bookingSummary: "/salon/booking-summary",
    thanks: "/salon/thanks",
  },
  fitness: {
    home: (categoryId) => `/fitness/${categoryId}`,
    subscription: (categoryId) => `/fitness/subscription/${categoryId}`,
    slotSelection: "/fitness/slots-selection",
    bookingSummary: "/fitness/booking-summary",
    thanks: "/fitness/thanks",
  },
  carwash: {
    home: (categoryId) => `/carwash/${categoryId}`,
    services: (categoryId) => `/carwash/${categoryId}/services`,
    vehicleType: (categoryId) => `/carwash/${categoryId}/vehicle-type`,
    vehicleBrand: (categoryId) => `/carwash/${categoryId}/vehicle-brand`,
    selectVehicle: (categoryId) => `/carwash/${categoryId}/select-vehicle`,
    washDetails: (categoryId) => `/carwash/${categoryId}/wash-details`,
    cart: (categoryId) => `/carwash/${categoryId}/cart`,
    slotBook: (categoryId) => `/carwash/${categoryId}/slot-book`,
    summary: (categoryId) => `/carwash/${categoryId}/summary`,
    thanks: (categoryId) => `/carwash/${categoryId}/thanks`,
    subscriptionDetails: (categoryId, subscriptionId) => `/carwash/${categoryId}/subscription/${subscriptionId}`,
  },
  laundry: {
    home: (categoryId) => `/laundry/${categoryId}`,
    services: (categoryId) => `/laundry/${categoryId}/services`,
    slotBook: (categoryId) => `/laundry/${categoryId}/slot-book`,
    summary: (categoryId) => `/laundry/${categoryId}/summary`,
    thanks: (categoryId) => `/laundry/${categoryId}/thanks`,
    subscriptionDetails: (categoryId, subscriptionId) => `/laundry/${categoryId}/subscription/${subscriptionId}`,
  },
  community: {
    list: `/community/post`,
    createPost: `/community/post/create`,
    profile: "/community/profile",
  },
  myBookings: {
    list: "/my-bookings",
    cancel: "/cancel-booking",
  },
  offlineVouchers: {
    list: "/my-vouchers",
  },
  cleaning: {
    home: (categoryId) => `/cleaning/${categoryId}`,
    services: (categoryId) => `/cleaning/${categoryId}/services`,
    slotBook: (categoryId) => `/cleaning/${categoryId}/slot-book`,
    summary: (categoryId) => `/cleaning/${categoryId}/summary`,
    thanks: (categoryId) => `/cleaning/${categoryId}/thanks`,
  },
  electrician: {
    home: (categoryId) => `/electrician/${categoryId}`,
    services: (categoryId) => `/electrician/${categoryId}/services`,
    slotBook: (categoryId) => `/electrician/${categoryId}/slot-book`,
    summary: (categoryId) => `/electrician/${categoryId}/summary`,
    thanks: (categoryId) => `/electrician/${categoryId}/thanks`,
  },
  plumber: {
    home: (categoryId) => `/plumber/${categoryId}`,
    services: (categoryId) => `/plumber/${categoryId}/services`,
    slotBook: (categoryId) => `/plumber/${categoryId}/slot-book`,
    summary: (categoryId) => `/plumber/${categoryId}/summary`,
    thanks: (categoryId) => `/plumber/${categoryId}/thanks`,
  },
  // Other routes
  notFound: "*",
};
